<template>
  <div class="home-page">
    <el-empty :image-size="200" description="功能暂未开放"></el-empty>
    <!--    <financialData></financialData>-->
    <!--    <storeOverview></storeOverview>-->
    <!--    <dataOverview></dataOverview>-->
  </div>
</template>

<script>
import storeOverview from "./template/storeOverview.vue";
import dataOverview from "./template/dataOverview.vue";
import financialData from "./template/financialData.vue";
export default {
  name: "Homepage",
  components: { storeOverview, dataOverview, financialData },
  data() {
    return {};
  },

  created() {},
  mounted() {},
  methods: {},
};
</script>
<style lang="scss" scoped>
.home-page {
  width: 100%;
  height: 100%;
  background-color: #ffffff;
  border-radius: 0.08rem;
  //position: relative;
  //z-index: 10;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
</style>
